export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/70817cde576618c8c72d63ef0f57a2ba.jpg"
          alt="Monarch Xpress Trucking"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-wide uppercase">
          Reliable Freight Solutions<br />Across All 48 States
        </h1>
        <p className="text-xl md:text-2xl text-white mb-10 font-light">
          Dry Van &amp; Flatbed Transportation | Cross Dock | Warehousing | Final Mile Delivery
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-green-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-green-700 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            Request Quote
            <i className="ri-arrow-right-line"></i>
          </button>
          <button
            onClick={() => scrollToSection('fleet')}
            className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
          >
            View Our Fleet
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}